<app-toolbar class="toolbar"></app-toolbar>

<div class="flex pt-[60px] min-h-screen">
  <!-- Sidebar -->
  <app-sidebar class="flex-shrink-0"></app-sidebar>

  <!-- Conteúdo -->
  <div class="flex-1 flex flex-col relative ">
    @if (!mapMode) {
      <div class="absolute top-2 left-0 right-0 z-20 px-2">
        <app-breadcrumb-card></app-breadcrumb-card>
      </div>
    }
    <div class="flex-1">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
@if (showAvisoLegal) {
  <app-aviso-legal [(showDialog)]="showAvisoLegal"></app-aviso-legal>
}
